








import {Component, Prop, Vue} from 'vue-property-decorator';
import {IMenuItem} from '../store/modules/menu.store';

@Component({
	components: {
	},
})
export default class ItemSearchResult extends Vue {
	@Prop({required: true})
	item!: IMenuItem;

	@Prop({required: true})
	htmlText!: string;


	created() {
		// console.log(this.htmlText);
	}
}
